import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { QUESTION } from '@constants/terminology';
import { useState } from 'react';
import { MergedValueListOption } from '@g17eco/types/initiativeUniversalTracker';
import { isDuplicatedOption } from './utils';
import { normalizeText } from '@utils/string-format';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  options: MergedValueListOption[];
  updateOptions: (newOptions: MergedValueListOption[]) => void;
}
export const AddOptionModal = ({ isOpen, toggle, options, updateOptions }: Props) => {
  const [value, setValue] = useState('');
  const code = normalizeText(value); // To be compatible with user added custom options so won't break aggregation.
  const isDuplicated = isDuplicatedOption(options, { code, name: value });

  const handleSubmit = () => {
    if (value && !isDuplicated) {
      const newOptions = [...options, { code, name: normalizeText(value, { lowerCase: false }), isCustom: true }]; // Keep case sensitive name.
      updateOptions(newOptions);
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static'>
      <ModalHeader toggle={toggle}>Add new option</ModalHeader>
      <ModalBody>
        <p>Newly added options are available to all instances of this {QUESTION.SINGULAR} on the platform.</p>
        <h6 className='text-ThemeTextDark'>Option name</h6>
        <Input
          className='w-100'
          placeholder='Enter dropdown option name...'
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        {isDuplicated ? (
          <p className='mt-2 mb-0 text-sm text-ThemeDangerExtradark'>Option name already exists</p>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color='link-secondary' onClick={toggle}>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSubmit} disabled={!value || isDuplicated}>
          Add custom option
        </Button>
      </ModalFooter>
    </Modal>
  );
};
